import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { localeFormattedNumber } from "utilities/utilities";
import { translateDefaultEntity } from "utilities/localesUtilities";
import { IMainSmallTable } from "./MainSmallTableInterfaces";
import { useStyles } from "./MainSmallTable.styles";
import { DefaultTranslationFieldsInTable } from "constants/constants";

const MainSmallTable = ({
    data,
    total,
    countryCode,
    labelTitle,
    valueTitle,
    disableInteraction,
    onClickRow,
    selectedRow,
}: IMainSmallTable) => {
    const classes = useStyles();
    const { t, i18n } = useTranslation();

    return (
        <TableContainer className={classes.tableContainer}>
            <Table size="small">
                <TableHead>
                    <TableRow>
                        <TableCell className={`${classes.tableCell} ${classes.tableCellPadding}`}>
                            <Typography variant="subtitle2" className={classes.title}>
                                {labelTitle}
                            </Typography>
                        </TableCell>
                        <TableCell align="right" className={`${classes.tableCellPadding}`}>
                            <Typography variant="subtitle2" className={classes.title}>
                                {valueTitle}
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {data.map((dataItem) => {
                        const defaultFailureTypeTranslatedName = translateDefaultEntity(
                            i18n.language,
                            dataItem,
                            "name",
                            DefaultTranslationFieldsInTable.FAILURE_TYPE,
                        );
                        return (
                            <TableRow
                                onClick={() => onClickRow && onClickRow(dataItem)}
                                className={`${classes.tableRow} ${!disableInteraction ? classes.tableRowHover : ""} ${
                                    selectedRow?.id === dataItem.id && !disableInteraction
                                        ? classes.tableRowSelected
                                        : ""
                                }`}
                                key={dataItem.id}
                            >
                                <TableCell
                                    className={`${classes.tableCell} ${classes.tableCellPadding}`}
                                    component="th"
                                    scope="row"
                                >
                                    <div className={classes.labelWrapper}>
                                        {dataItem.color_code && (
                                            <div
                                                className={classes.dot}
                                                style={{
                                                    background: dataItem.color_code,
                                                }}
                                            />
                                        )}
                                        <Typography variant="h6">{defaultFailureTypeTranslatedName}</Typography>
                                    </div>
                                </TableCell>
                                <TableCell align="right" className={`${classes.tableCellPadding}`}>
                                    <Typography variant="h6">
                                        {localeFormattedNumber(countryCode, dataItem.value)}
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        );
                    })}
                    <TableRow className={classes.tableRow}>
                        <TableCell className={classes.tableCellPadding}>
                            <Typography variant="subtitle2" className={`${classes.title} ${classes.total}`}>
                                {t("main_small_table.total")}
                            </Typography>
                        </TableCell>
                        <TableCell align="right" className={`${classes.tableCellPadding}`}>
                            <Typography variant="h6" className={classes.total}>
                                {localeFormattedNumber(countryCode, total)}
                            </Typography>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default MainSmallTable;
